var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkinPreparation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8329_590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3706 5.97656H8.74126C6.70206 5.97656 5.04895 7.46891 5.04895 9.3099V10.219H19.0629V9.3099C19.0629 7.46891 17.4098 5.97656 15.3706 5.97656Z",
    fill: "#4807EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.04895 20.1812C5.04895 21.018 5.80038 21.6963 6.72727 21.6963H17.3846C18.3115 21.6963 19.0629 21.018 19.0629 20.1812V17.416H5.04895V20.1812Z",
    fill: "#4807EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.035 2.87092C15.035 2.55713 14.7532 2.30273 14.4056 2.30273H9.70629C9.35871 2.30273 9.07692 2.55713 9.07692 2.87092V4.84061H15.035V2.87092Z",
    fill: "#4807EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.94775,
    y: 11.4297,
    width: 14.2164,
    height: 4.84848,
    fill: "#4807EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8329_590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20,
    fill: "white",
    transform: "translate(4 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkinPreparation);
export default __webpack_public_path__ + "static/media/skin_preparation.8b0ea459cdceb48078176a5d21c51a5b.svg";
export { ForwardRef as ReactComponent };